import { MediaStatus, UploadTypes } from '../utils';

interface Uploads {
  url: string;
  type?: UploadTypes;
}

export enum AvatarStatus {
  NotStarted = 'NotStarted',
  InProgress = 'InProgress',
  Success = 'Success',
  Error = 'Error',
}

export interface Avatar {
  id: string;
  name: string;
  userId: string;
  isPublic: boolean;
  uploadId: string;
  status: MediaStatus;
  thumbnail: string;
  processedAvatar: string | null;
  createdAt: string;
  updatedAt: string;
  uploads: Uploads;
  metaData?: { heyGenGroupId?: string; heyGenMotionId?: string};
}
